"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uf_fora_do_sin_1 = __importDefault(require("./erros/uf-fora-do-sin"));
var enums_1 = require("./data/enums");
var SUBMERCADO_POR_UF = {
    AC: enums_1.Submercado.SUDESTE,
    AL: enums_1.Submercado.NORDESTE,
    AP: enums_1.Submercado.NORTE,
    AM: enums_1.Submercado.NORTE,
    BA: enums_1.Submercado.NORDESTE,
    CE: enums_1.Submercado.NORDESTE,
    ES: enums_1.Submercado.SUDESTE,
    GO: enums_1.Submercado.SUDESTE,
    MA: enums_1.Submercado.NORTE,
    MT: enums_1.Submercado.SUDESTE,
    MS: enums_1.Submercado.SUDESTE,
    MG: enums_1.Submercado.SUDESTE,
    PA: enums_1.Submercado.NORTE,
    PB: enums_1.Submercado.NORDESTE,
    PR: enums_1.Submercado.SUL,
    PE: enums_1.Submercado.NORDESTE,
    PI: enums_1.Submercado.NORDESTE,
    RJ: enums_1.Submercado.SUDESTE,
    RN: enums_1.Submercado.NORDESTE,
    RS: enums_1.Submercado.SUL,
    RO: enums_1.Submercado.SUDESTE,
    SC: enums_1.Submercado.SUL,
    SP: enums_1.Submercado.SUDESTE,
    SE: enums_1.Submercado.NORDESTE,
    TO: enums_1.Submercado.NORTE,
    DF: enums_1.Submercado.SUDESTE,
};
var SistemaInterligadoNacional = /** @class */ (function () {
    function SistemaInterligadoNacional() {
    }
    SistemaInterligadoNacional.getSubmercadoByUF = function (uf) {
        if (SUBMERCADO_POR_UF[uf]) {
            return SUBMERCADO_POR_UF[uf];
        }
        throw new uf_fora_do_sin_1.default();
    };
    return SistemaInterligadoNacional;
}());
exports.default = SistemaInterligadoNacional;
